function ransackFormat(params) {
  const formatedParams = [];

  Object.keys(params).forEach((key) => {
    const newKey = `q[${key}]`;
    formatedParams[newKey] = params[key];
  });

  return formatedParams;
}

export default ransackFormat;
